import {
  QueryCondition,
  QueryOperation,
  SearchQuery,
} from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import { nameOf } from "../utils/typescript";
import _ from "lodash";
import { hasValue } from "../utils/string";
import { InputObject } from "../controls/default";

export interface CompanyPoliciesViewForm {
  readonly name: string;
  readonly code: string;
  readonly pdfUrl: string;
}

export const companyPoliciesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
        fixed: 'left'
  },
  {
    title: "Code",
    key: "code",
    width: 192,
    sort: true,
  },
];

export function mapCompanyPoliciesViewQuery(
  values: CompanyPoliciesViewForm,
): SearchQuery {
  const conditions: QueryCondition[] = Object.entries(values)
        .filter(([key, value]) =>
      hasValue(value),
    )
    .map(([key, value]) => {
      switch (key) {
        case nameOf<CompanyPoliciesViewForm>("name"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<CompanyPoliciesViewForm>("code"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
      }
    })
    .filter((f) => !!f) as QueryCondition[];

  return {
    conditions,
  };
}
